// extracted by mini-css-extract-plugin
export default {"mainsignup":"signup_mainsignup__e85Ps"};